import { render, staticRenderFns } from "./DataEditionCreate.vue?vue&type=template&id=17318c90&"
import script from "./DataEditionCreate.vue?vue&type=script&lang=js&"
export * from "./DataEditionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports